<template >
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group pl-5 pt-1">
              <div class="dropdown ml-3">
                <button
                  class="btn green-color dropdown-toggle"
                  type="button"
                  id="dropdownMenuButtonSearch"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ dropDownRoleName }}
                </button>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButtonSearch"
                  style="max-height: 400px; overflow: hidden auto"
                >
                  <a
                    class="dropdown-item pointer"
                    v-for="item in rolesArray"
                    :key="item.id"
                    @click="dropDownRoleClick(item.name, item.id)"
                    >{{ item.name }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-group">
            <i
              class="fa fa-plus-circle addNewBtn mt-1 ml-4"
              title="როლის დამატება"
              data-toggle="modal"
              data-target="#addRoleModal"
              data-backdrop="static"
              data-keyboard="false"
              @click="clearData()"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">გვერდი</th>
            <th class="numeric">ნახვა</th>
            <th class="numeric">დამატება</th>
            <th class="numeric">რედაქტირება</th>
            <th class="numeric">წაშლა</th>
          </tr>
        </thead>
        <tbody>
          <tr class="heading" v-for="value in dataArray" :key="value.id">
            <td data-title="გვერდი" class="numeric">
              {{ value.name }}
            </td>
            <td data-title="ნახვა" class="numeric">
              <input
                type="checkbox"
                class="form-check-input"
                style="margin-left: 0px"
                v-model="value.view.hasRight"
                :disabled="!value.view.isEditable"
                @change="editRolePermissionClick(value.pageId, 'view', roleId)"
              />
            </td>
            <td data-title="დამატება" class="numeric">
              <input
                type="checkbox"
                class="form-check-input"
                style="margin-left: 0px"
                v-model="value.add.hasRight"
                :disabled="!value.add.isEditable"
                @change="editRolePermissionClick(value.pageId, 'add', roleId)"
              />
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <input
                type="checkbox"
                class="form-check-input"
                style="margin-left: 0px"
                id="id1"
                v-model="value.edit.hasRight"
                :disabled="!value.edit.isEditable"
                @change="editRolePermissionClick(value.pageId, 'edit', roleId)"
              />
            </td>
            <td data-title="წაშლა" class="numeric">
              <input
                type="checkbox"
                class="form-check-input"
                style="margin-left: 0px"
                id="id1"
                v-model="value.delete.hasRight"
                :disabled="!value.delete.isEditable"
                @change="
                  editRolePermissionClick(value.pageId, 'delete', roleId)
                "
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--New form-->
    <div
      class="modal fade bd-example-modal-lg"
      id="addRoleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              როლის დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="inputUserName"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="role.descGeo"
                      v-on:input="$v.role.$touch"
                      v-bind:class="{
                        'error-border': $v.role.descGeo.$error,
                        valid:
                          $v.role.descGeo.$dirty && !$v.role.descGeo.$invalid,
                      }"
                    />
                    <label for="inputUserName">სახელი ქართულად</label>
                  </div>
                  <div class="form-label-group mt-3">
                    <input
                      type="text"
                      id="inputEmail"
                      class="form-control"
                      placeholder="English Name"
                      autofocus="autofocus"
                      v-model="role.descEng"
                      v-on:input="$v.role.$touch"
                      v-bind:class="{
                        'error-border': $v.role.descEng.$error,
                        valid:
                          $v.role.descEng.$dirty && !$v.role.descEng.$invalid,
                      }"
                    />
                    <label for="inputEmail">English Name</label>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="inputMobile"
                      class="form-control"
                      placeholder="имя на русском"
                      autofocus="autofocus"
                      v-model="role.descRus"
                      v-on:input="$v.role.$touch"
                      v-bind:class="{
                        'error-border': $v.role.descRus.$error,
                        valid:
                          $v.role.descRus.$dirty && !$v.role.descRus.$invalid,
                      }"
                    />
                    <label for="inputMobile">имя на русском</label>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.role.$dirty || $v.role.$error"
              @click="$v.role.$touch(), addRole()"
              data-dismiss="modal"
            >
              დამატება
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "roleManagement",
  data() {
    return {
      dataArray: [],
      rolesArray: [],
      dropDownRoleName: "აირჩიე როლი",
      roleId: null,
      role: {
        descGeo: null,
        descEng: null,
        descRus: null,
      },
    };
  },
  validations: {
    role: {
      descGeo: {
        required,
      },
      descEng: {
        required,
      },
      descRus: {
        required,
      },
    },
  },
  async created() {
    //let result = await this.$http.geRolePermissions({ roleId: this.roleId });
    //this.dataArray = result.data.res;

    let rolesResult = await this.$http.getRoles();
    this.rolesArray = rolesResult.data.res;
  },
  methods: {
    async dropDownRoleClick(name, id) {
      this.dropDownRoleName = name;
      this.roleId = id;

      let result = await this.$http.geRolePermissions({ roleId: id });
      this.dataArray = result.data.res;
    },
    async editRolePermissionClick(pageId, operation, roleId) {
      await this.$http.editRolePermissions({
        PageId: pageId,
        Operation: operation,
        RoleId: roleId,
      });
    },
    async addRole() {
      try {
        let result = await this.$http.addRole({
          DescriptionGeo: this.role.descGeo,
          DescriptionEng: this.role.descEng,
          DescriptionRus: this.role.descRus,
        });
        if (result.data.res === "200") {
          bus.$emit("success", "როლი წარმატებით დაემატა");
          let rolesResult = await this.$http.getRoles();
          this.rolesArray = rolesResult.data.res;
        } else {
          bus.$emit("warning", "როლის დამატების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    clearData() {
      this.role.descGeo = null;
      this.role.descEng = null;
      this.role.descRus = null;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/RoleManagement.vue